import { AppSettingCacheMixin } from './AppSettingCacheMixin'

export const SiteBookingSettingMixin = {
  mixins: [AppSettingCacheMixin],
  computed: {
    settingKey () {
      return 'Booking'
    },
    siteBookingSettingEnabled () {
      return this.settingObject?.bookingEnabled || false
    },
    siteBookingSettingClientType () {
      return this.settingObject?.clientType || 1
    },
    siteBookingSettingServiceSelectEnabled () {
      return this.settingObject?.serviceSelectEnabled || false
    },
    siteBookingSettingServiceMinNotice () {
      const parsedValue = parseInt(this.settingObject?.minNotice || 1) || NaN
      return !isNaN(parsedValue) ? parsedValue : 1
    },
    siteBookingSettingServiceMinNoticeUnit () {
      return this.settingObject?.minNoticeUnit || 'days'
    },
    siteBookingSettingServiceMaxNotice () {
      const parsedValue = parseInt(this.settingObject?.maxNotice || 30) || NaN
      return !isNaN(parsedValue) ? parsedValue : 30
    },
    siteBookingSettingServiceMaxNoticeUnit () {
      return this.settingObject?.maxNoticeUnit || 'days'
    },
    siteBookingSettingPricingType () {
      return this.settingObject?.pricingType || 1
    },
    siteBookingSettingDisplayServicePrices () {
      return this.settingObject?.displayServicePrices || false
    },
    siteBookingSettingDisplayServiceDescriptions () {
      return this.settingObject?.displayServiceDescriptions || false
    },
    siteBookingSettingMultipleServiceEnabled () {
      return this.settingObject?.multipleServiceEnabled || false
    },
    allowedMultipleServiceSelect () {
      return (this.siteBookingSettingPricingType === 1 || this.siteBookingSettingPricingType === 4) &&
        this.siteBookingSettingMultipleServiceEnabled
    },
    siteBookingSettingSinglePetResourceEnabled () {
      return this.settingObject?.singlePetResourceEnabled || false
    },
    siteBookingSettingMaxPets () {
      const parsedValue = parseInt(this.settingObject?.maxPets || 6) || NaN
      return !isNaN(parsedValue) ? parsedValue : 6
    },
    siteBookingSettingMaxRegisteredPets () {
      const parsedValue = parseInt(this.settingObject?.maxRegisteredPets || 10) || NaN
      return !isNaN(parsedValue) ? parsedValue : 10
    },
    siteBookingSettingMaxServices () {
      const parsedValue = parseInt(this.settingObject?.maxServices || 4) || NaN
      return !isNaN(parsedValue) ? parsedValue : 4
    },
    siteBookingSettingDisplayPetProfileImage () {
      return this.settingObject?.displayPetProfileImage || false
    },
    siteBookingSettingBlockOffEvents () {
      return this.settingObject?.blockOffEvents || false
    },
    siteBookingSettingUnregisteredClientAddressRequired () {
      return this.settingObject?.unregisteredClientAddressRequired || false
    },
    siteBookingSettingRegisteredClientAddressRequired () {
      return this.settingObject?.registeredClientAddressRequired || false
    },
    siteBookingSettingDisplayResourceNameInSummary () {
      return this.settingObject?.displayResourceNameInSummary || false
    },
    siteBookingSettingServiceBasedDurationEnabled () {
      return this.settingObject?.serviceBasedDurationEnabled || false
    },
    siteBookingSettingDisplayBookingDuration () {
      return this.settingObject?.displayBookingDuration || false
    },
    siteBookingSettingStackGroupBooking () {
      return this.settingObject?.stackGroupBooking || false
    },
    siteBookingSettingResourceTimeSlotsEnabled () {
      return this.settingObject?.resourceTimeSlotsEnabled || false
    },
    defaultSettingObject () {
      return {
        bookingEnabled: false,
        clientType: 2,
        reviewType: 0,
        serviceSelectEnabled: true,
        pricingType: 1,
        displayServicePrices: true,
        displayServiceDescriptions: false,
        multipleServiceEnabled: false,
        minNotice: 1,
        minNoticeUnit: 'days',
        maxNotice: 30,
        maxNoticeUnit: 'days',
        singlePetResourceEnabled: true,
        maxPets: 6,
        maxRegisteredPets: 10,
        maxServices: 4,
        displayPetProfileImage: false,
        blockOffEvents: true,
        unregisteredClientAddressRequired: false,
        registeredClientAddressRequired: false,
        displayResourceNameInSummary: false,
        serviceBasedDurationEnabled: false,
        displayBookingDuration: false,
        stackGroupBooking: false,
        resourceTimeSlotsEnabled: false
      }
    }
  }
}
